import React from 'react'

import HorizontalTabs from '../components/HorizontalTabs';
import { Link } from 'react-router-dom';
import { text } from '@fortawesome/fontawesome-svg-core';


function policy() {

  const tabs = [
    { title: 'Admission Policy', content: () => <div>
    
    <div className='cam-lower-sec'>
    <h1 className='title'>Admission Policy</h1>
    </div>

    <div className='newsletter-sec-row'>
          <div className='newletter-box'>
            <Link to="../policy/IB Admission Policy.pdf"
              target="_blank"
              rel="noopener noreferrer"> 
            <div className='newletter-img'>
              <img src="../policy/IB Admission Policy.webp" alt="" />
            </div>
            <div className='newsletter-heading'>
              <p>Admission Policy</p>
          
            </div>
            </Link>
          </div>
       </div>



      
    </div> },
   {title: 'Assessment Policy', content: () => <div>
      <div className='cam-lower-sec'>
    <h1 className='title'>Assessment Policy</h1>
    </div>

       <div className='newsletter-sec-row'>
          <div className='newletter-box'>
            <Link to="../policy/Assessment-Policy.pdf"
              target="_blank"
              rel="noopener noreferrer"> 
            <div className='newletter-img'>
              <img src="../policy/Assessment-Policy.webp" alt="" />
            </div>
            <div className='newsletter-heading'>
              <p>Assessment Policy </p>
          
            </div>
            </Link>
          </div>
       </div>


        </div>


    },
//     { title: 'Assessment Policy', content: () => <div>
//      <div className='cam-lower-sec'>
//     <h1 className='title'>Assessment Policy</h1>
//       <h5 className='cam-title-heading'>Sanskar School aims to:</h5>
//       <ul>
//           <li>equip its pupils with a <b>critical and global outlook </b>which will make them committed citizens of the world.</li>
//           <li>recognize <b> and channelize the potential</b> of the pupil and develop thinking, communication, social, scientific and interpersonal skills.</li>
//           <li>Foster <b>cognitive, affective and psychomotor development</b> and enable the pupil to make connections with the acquired knowledge in his/her everyday life.</li>
//         </ul>
//         <br/>
//         <br />
// <p>Assessment is an integral part of the teaching learning process at Sanskar School. It allows
// achievements to be recognized and helps both teachers and learners to reflect on and review
// their performance and progress. It is the process that focuses on holistic development.</p>
// <p>Assessment is a tool used by the teachers to continuously monitor students’ progress in a nonthreatening, friendly and supportive environment. It involves regular descriptive feedback, a chance for the students to reflect on their performance, take advice and improve.</p>
// <p>In addition to this, assessment is totally stress free and enjoyable for the students at Sanskar School, and also develops in them the spirit of competitiveness and self-assessment.</p>
// <br/>
// <h5 className='cam-title-heading'> <b>The objectives of assessment at Sanskar School are:</b></h5>
//       <ul className='admission-class'>
//        <li>to support and enhance student learning.</li>
//        <li>to be diagnostic, evaluative and remedial.</li>
//        <li>to focus on all key areas of student learning and development i.e., Scholastic and Coscholastic as it helps to ascertain strengths and weaknesses of the learner.</li>
//        <li>to have a variety of assessment tools catering to varying needs of a learner.</li>
//        <li>to make assessments continuous as well as comprehensive.</li>
//        <li>to help develop cognitive, psychomotor and affective skills.</li>
//        <li>to use evaluation for the improvement of students’ achievement and teaching- learning
//        strategies on the basis of regular diagnosis followed by remedial instructions.</li>
//        <li>to give importance to each learner’s way of responding and learning and time it takes to
//        do so.</li>
//        <li>to report on a continuous basis and be sensitive to each learner’s response.</li>
//        <li>to provide feedback that will lead to positive action and help the learner to do better.</li>
//         </ul>
//         <br/>
//           <h5 className='cam-title-heading'><b>Assessment focuses on the learner’s ability to:</b></h5>
//         <ul className='admission-class'>
//           <li>learn and acquire desired skills related to different subject areas.</li>
//           <li>acquire a level of achievement in different subject areas in the requisite measure.</li>
//           <li>develop individual skills, interest, attitude and motivation.</li>
//           <li>respond to different situations and opportunities both in and out of school.</li>
//           <li>apply what is learnt in a varied of environment, circumstances and situations.</li>
//           <li>manifest academic honesty in all their internal and external assessment.</li>
//           <li>work independently, collaboratively and harmoniously.</li>
//           <li>reflect, analyze and evaluate and taking action.</li>
//         </ul> 
//      <br/>
//     <h5 className='cam-title-heading'><b>Evaluation System:</b></h5>

// <p>The system of evaluation followed at Sanskar School is a Continuous and Comprehensive
// Evaluation system which refers to a system of school based on the evaluation of a student that
// covers all aspects of a student development in a continuous process rather than in an event. It is
// built into the total teaching-learning process and spread over the entire span of the academic
// session.</p>
// <br/>
// <h5 className='cam-title-heading'><b>Examination Pattern and Grading (Assessment Criterion Being Used):For PYP – Pre Primary to Grade V.</b></h5>
//           <br />
// <h5 className='cam-title-heading'><b>Evaluation System:</b></h5>
// <p>The system of evaluation followed at Sanskar School is Continuous and Comprehensive
// Evaluation system which refers to a system of school based evaluation of a student that
// covers all aspects of a student development in a continuous process rather than an event, it
// is built into the total teaching-learning process and spread over the entire span of
// academic session.</p>
// <p>Assessments are designed in order to assess the essential elements of PYP (knowledge,
// concepts, ATL, attributes and action) and promote the acquisition of IB Learner profiles for
// evolution of international mindedness.</p>
// <br/>
// <p><b>Pre-Assessment</b> occurs before the beginning of new learning to uncover prior knowledge
// and experiences.</p>
// <br/>
// <p><b>Formative Assessment</b> is a tool used by the teachers to continuously monitor student
// progress in a nonthreatening, supportive environment.</p>
// <br/>
// <p>Formative Assessment is carried out during a course of instruction for providing continuous feedback to both the teachers and the learners. It is also carried out for taking decisions regarding appropriate modifications in the transactional procedures and learning activities.</p>
// <br/>
// <p><b>Summative Assessment</b> is carried out at the end of the course of learning. It measures or ‘sums-up’ how much student has learned from the course. Summative assessment is assessment of conceptual understanding within the central idea.</p>
// <br/>
// <h5 className='cam-title-heading'><b>Term-1 and Term-2 Assessment tools and strategies:</b></h5>
// <p>The assessment of the development and learning of young students is an essential component of the curriculum. Students are observed in the variety of situations and a range of assessment strategies are implemented. Tools such as rubrics, exemplars,
// checklist and anecdotal records and strategies such as observations, performance assessments, selective responses and open-ended tasks are selected in order to provide a balanced view of the students.</p>
// <br/>
// <h5 className='cam-title-heading'><b>Reporting Criteria (PYP)</b></h5>
// <p>A four-point grading scale is followed with the description as follows:</p>
// <br/>
// <p><b>Excelling (point -4):</b> Has achieved expected requirements and consistently provide evidence of learning that is high in quality. Analyses situations and applies knowledge, skills and understanding.</p>
// <p><b>Achieving (point-3):</b> Has met the expected requirements and provide quality work evidence most of the time.Demonstrates and applies knowledge, skills and understanding.</p>
// <p><b>Developing (point-2):</b> Has partially achieved the requirements and provides some work evidence. Needs help to apply knowledge, skills and understanding.</p>
// <p><b>Beginning (point-1):</b> Is beginning to develop knowledge, skills and understanding. Is unable to discuss independently, his /her learning in meaningful ways with others</p>
// <br />
// <h5 className='cam-title-heading'><b>Reporting:</b></h5>
// <p>Regular reporting is done on a one to one basis to the parents during Open House Sessions which are organised on a regular basis throughout the session.</p>
// <p>Through two and three way of conference students share their learning process with the parents and teachers.</p>
// <p>Written reporting of the student’s progress is done twice a year, once at the end of each semester/term. Parents collect their ward’s written report and feedback and remedial measures are shared with the parents.</p>
// <p>The performance of a student is graded, based on a 4-point scale with descriptive indicators given at the end of the Performance Profile.</p>
// <br/>
// <h5 className='cam-title-heading'><b>For classes VI to VIII (CBSE)</b></h5>
// <ul className='admission-class' typeof='i'>
// <li>Introduction of Periodic Test Evaluation in classes VI to VIII is spread in an academic year. Each term has one Unit Test.</li>
// <li>The assessment structure and examination for classes VI to VIII is as follows: -</li>
// </ul>
// <br/> 
// <div className='cam-lower-table policy'>
//      <table>
//        <thead>
//          <tr>
//           <th>Subjects</th>
//            <th colSpan={2}>
//             <p><b>TERM-1 (100 marks)</b></p>
//             <p><b>(1<sup>st</sup>  half of the session)</b></p>
//             <p><b>20 marks Periodic Assessment + 80 marks for Term-1 Exam</b></p>
//             </th>
//            <th colSpan={2}>
//            <p><b>TERM-2 (100 marks)</b></p>
//            <p><b>(2<sup>nd</sup>  half of the session)</b></p>
//            <p><b>20 marks Periodic Assessment + 80 marks for Term-2 Exam</b></p>
//           </th> 
//          </tr>
//        </thead>
//        <tbody>
//          <tr>
//            <td>
//             <p><b>English</b></p>
//             <p><b>Hindi</b></p>
//             <p><b>Sanskrit/French</b></p>
//             <p><b>Mathematics</b></p>
//             <p><b>Science</b></p>
//             <p><b>Social Science</b></p>
//             <p><b>Computer Science</b></p>
//            </td>
//            <td>
//            <h5 className='cam-title-heading'>PA 20 marks</h5><br></br>
//            <p>Periodic Test 10 marks with syllabus covered till announcement of test dates by school.</p><br></br>
//            <p>Note Book Submission 5 marksat term end.</p><br></br>
//            <p>Sub Enrichment 5 marks at term end.</p><br></br>
//            </td>
//            <td>
//            <h5 className='cam-title-heading'>Term-1 Exam</h5>
//             <br></br>
//             <p>Written exam for 80 marks with syllabus covered till announcement of Term-1 exam dates by school.</p>
//            </td>
//            <td>
//            <h5 className='cam-title-heading'>PA 20 marks</h5><br></br>
//            <p>Periodic Test </p><br></br>
//            <p>10 marks with syllabus covered till announcement of test dates by school</p><br></br>
//            <p>Note Book submission 5 marks at term end</p><br></br>
//            <p>Sub Enrichment 5 marks at term end</p><br></br>
//         </td>
//            <td>
//            <h5 className='cam-title-heading'>Term-2 Exam</h5><br></br>
//            <p>Written exam for 80 marks with syllabus coverage as below:</p><br></br>
//            <p><b>Class VI:</b> 10% of1<sup>st </sup> term covering significant topics + entire syllabus of 2<sup>nd</sup> term </p><br></br>
//            <p><b>Class VII:</b> 20% of 1<sup>st</sup> term covering significant topics + entire syllabus of 2<sup>nd</sup> term</p><br></br>
//            <p><b>Class VIII:</b> 30% of 1<sup>st</sup> term covering significant topics + entire syllabus of 2<sup>nd</sup> term </p><br></br>
//            </td>
//          </tr>
//         </tbody>
//       </table>
//     </div>
//     <br/> 
// <p><b>Co-Scholastic Activities (Classes VI-VIII):</b> For the holistic development of the student, cocurricular activities in the following areas be carried out in CBSE affiliated schools by the teachers and will be graded term-wise on a 3-point grading scale (A= Very Good, B= Good and C= Fair).The aspect of regularity, sincere participation, output and teamwork be the generic  criteria for grading in the following co-scholastic activities:</p>
//       <ul className='admission-class' typeof='a'>
//           <li><b>Work Education-</b> Work Education refers to skill-based activities resulting in goods or services useful to the community</li>
//           <li><b>Art Education</b> (Visual & Performing Art)</li>
//           <li><b>Health and Physical Education</b> (Sports/Martial Arts/Yoga/NCC etc.)</li>
//         </ul>
//         <br/>
//         <h5 className='cam-title-heading'><b>Scholastic grade points in VI to VII:</b></h5><br></br>
//         <div className='cam-lower-table policy'>
//      <table>
//        <thead>
//          <tr>
//            <th>
//             <p><b>MARKS RANGE</b></p>
//             </th>
//            <th>
//             <p><b>MARKS RANGE</b></p>
//             </th>
//          </tr>
//        </thead>
//        <tbody>
//          <tr>
//            <td>
//            <p><b>91-100</b></p>
//            </td>
//            <td>
//            <p><b>A1</b></p>
//            </td>
//          </tr>
//          <tr>
//            <td>
//            <p><b>81-90</b></p>
          
//            </td>
//            <td>
//            <p><b>A2</b></p>
//            </td>
//          </tr>
//          <tr>
//            <td>
//            <p><b>71-80</b></p>
//            </td>
//            <td>
//            <p><b>B1</b></p>
//            </td>
//          </tr>
//          <tr>
//          <td>
//          <p><b>61-70</b></p>
//            </td>
//            <td>
//            <p><b>B2</b></p>
//            </td>
//          </tr>
//          <tr>
//          <td>
//          <p><b>51-60</b></p>
//            </td>
//            <td>
//            <p><b>C1</b></p>
//            </td>
//          </tr>
//          <tr>
//          <td>
//          <p><b>41-50</b></p>
//            </td>
//            <td>
//            <p><b>C2</b></p>
//            </td>
//          </tr>
//          <tr>
//          <td>
//          <p><b>33-40</b></p>
//            </td>
//            <td>
//            <p><b>D</b></p>
//            </td>
//          </tr>
//          <tr>
//          <td>
//          <p><b>30 & BELOW</b></p>
//            </td>
//            <td>
//            <p><b>E</b></p>
//            </td>
//          </tr>
//         </tbody>
//              </table>
//              </div> 
// <br/>
// <p><b>Discipline (Classes VI-VIII):</b> The students will be assessed for the discipline which will be based on the factors like attendance, sincerity, behavior, values and tidiness, respectfulness for rules and regulations, attitude towards society, nation and others. Grading on Discipline will be done term-wise on a 3-point grading scale (A= Outstanding,B= Very Good and C= Fair)
// </p>
// <br/>
// <h5 className='cam-title-heading'><b>Assessment for Classes IX – X (CBSE)</b></h5>
// <p>The assessment structure and examination for classes IX and X is as follows: -</p>
// <div className='cam-lower-table policy'>
//      <table>
//        <thead>
//          <tr>
//            <th></th>
//            <th>
//             <p><b>Classes IX- X </b></p>
//             </th>
//          </tr>
//        </thead>
//        <tbody>
//          <tr>
//            <td>
//             <p><b>Maximum marks  per subject: </b></p>
//            </td>
//            <td>
//            <p>100</p>
//            </td>
//          </tr>
//          <tr>
//            <td>
//             <p><b>Types of assessment</b></p>
//            </td>
//            <td>
//            <ul className='admission-class' > 
//             <li>Internal Assessment </li>
//             <li>Year End/Board Examination</li>
//             <li>School Based Assessment of Co- scholastic Areas (Art Education, Health and Physical Education including Work  Experience, Discipline)</li>
//             <li>Two Pre-Board examinations</li>
//            </ul>
//            </td>
//          </tr>
//          <tr>
//            <td>
//             <p><b>Marks distribution</b></p>
//            </td>
//            <td>
//            <p>Internal Assessment : Year End/Board</p>
//           <p>Examination</p>
//           <p>IT:                          50:50</p>
//           <p>All the other subjects:      20:80</p>
//           </td>
//          </tr>
//         </tbody>
//              </table>
//              </div> 
//              <br/>
//              <br/>
//         <div className='cam-lower-table policy'>
//      <table>
//        <thead>
//          <tr>
//            <th colSpan={3}> 
//             <p><b>Internal Assessment</b></p>
//             </th>
//          </tr>
//          <tr>
//            <th colSpan={3}> 
//             <p><b>Periodic Assessment</b></p>
//             </th>
//          </tr>
//        </thead>
//        <tbody>
//          <tr>
//            <td rowSpan={4}>
//             <p><b>Components of Internal Assessment</b></p>
//            </td>
//            <td>
//            <p><b>Pen Paper Test</b></p>
//            </td>
//            <td>5 marks</td>
//          </tr>
//          <tr>
//           <td>
//             <p><b>Multiple Assessment</b> strategies to be used. (Quizzes, oraltest, concept map, exit cards, visual expression etc.)</p>
//           </td>
//           <td>5 marks</td>
//          </tr>
//          <tr>
//           <td>
//             <p><b>Portfolio</b></p>
//             <p>(Classwork plus peer assessment, self -assessment, achievements of student in the subject, reflections, narrations, journals etc.)</p>
//           </td>
//           <td>5 marks</td>
//          </tr>
//          <tr>
//           <td>
//             <p><b>Subject enrichment</b></p>
//             <ul className='admission-class'>
//               <li>Social Science Project Work</li>
//               <li>Maths and Science practical work</li>
//               <li>ASL for English.</li>
//               <li>Subject enrichment work for English and Hindi</li>
//               <li>No changes in other subjects</li>
//             </ul>
//           </td>
//           <td>5 marks</td>
//          </tr>
//         </tbody>
//              </table>
//              </div> 

//              <br/>
//              <h5 className='cam-title-heading'><b>Assessment for Classes XI – XII (CBSE)</b></h5>
//              <p>Internal assessment conducted through 4 Unit Tests and 2 Examinations (Mid Term and Final Exam)</p>
//               <p>The assessment structure andexamination for classes XI and XII is as follows: -</p>
// <div className='cam-lower-table policy'> 
//      <table>
//        <thead>
//          <tr>
//            <th></th>
//            <th>
//             <p><b>Classes XI- XII </b></p>
//             </th>
//          </tr>
//        </thead>
//        <tbody>
//          <tr>
//            <td>
//             <p><b>Maximum marks  per subject: </b></p>
//            </td>
//            <td>
//            <p>100 marks</p>
//            </td>
//          </tr>
//          <tr>
//            <td>
//             <p><b>Types of assessment</b></p>
//            </td>
//            <td>
//            <ul > 
//             <li>Internal Assessment / Practical </li>
//             <li>Board Examination </li>
//             <li>Assessment of Co-scholastic areas (Health and Education Physical including Work Education, General Studies)</li>
//            <li>Two Pre-Board examinations.</li>
//            </ul>
//            </td>
//          </tr>
//          <tr>
//            <td>
//             <p><b>Marks distribution</b></p>
//            </td>
//            <td>
//            <ul> 
//             <p>Internal Assessment / Practical: Board Exam/ Year end Exam</p>
//             <li>30:70 (Applied Mathematics, Languages, Political Science) </li>
//             <li>20:80 (Humanities(Political Science, History, Economics) / Commerce Based Subjects (Accounts, Economics and BST) and some othersubjects) </li>
//             <li>30:70 (Science based subjects and some other subjects such as Physics, Chemistry, Biology, Mathematics, IP, PE, EP, Geography and Psychology)</li>
//             <li>70:30 (Commercial Arts and some other subjects)</li>
//             <li>50:50 Yoga</li>
//             <li>40:60 Financial Market Management</li>
//             <li>20:80 Legal Studies</li>
//            </ul>
//            </td>
//          </tr>
//         </tbody>
//              </table>
//              </div> 
// <br/>
// <h5 className='cam-title-heading'><b>Assessment Criteria of Classes VI-X (IGCSE)</b></h5>
// <p>The assessment policy for Cambridge Lower and Upper Secondary comprises both Formative and Summative assessment The Formative assessment policy includes-oral questions, quizzes, projects, listening and speaking skills. The Summative test includes written test/examinations. There are four-unit test, Term-1 and Term-2 Assessment.</p>

// <p><b>LOWER SECONDARY ASSESSMENT:</b> Grade 6 to 8 (Stage 7 to 9 of Cambridge) are assessed in English as a first Language, French as a Foreign Language, Hindi, Science, Mathematics, Social Science (History& Geography), ICT.</p>
// <br/>
// <p><b>CHECKPOINT EXAMINATION:</b></p>
// <p>Students of Grade 8 (Stage9) will appear for the Checkpoint Examination (May Series), conducted by CAMBRIDGE INTERNATIONAL.UK in English as a Second Language Mathematics and Science. The performance in the Checkpoint enables schools to obtain an
// international benchmark of learner performance to identify and address learning needs.</p>
// <p><b>UPPER SECONDARY ASSESSMENT:</b>Students of Grade 9 & 10 <b>(IGCSE YEAR 1& 2) </b>are assessed in 8 subjects as required to qualify for<b>INTERNATIONAL CAMBRIDGE EXAMINATION (ICE).</b></p>
// <p>It is compulsory for all the students to appear in following <b>Three</b>subjects:</p>
// <ol  className='admission-class' typeof='1'>
//   <li>English as a first Language. </li>
//   <li>Mathematics</li>
//   <li>Information & Communication Technology. </li>
// </ol>
// <p><b>The students have a choice to appear for the remaining five subjects:</b></p>
// <ol className='admission-class' typeof='1' start='4'>
//   <li>Global Perspectives/Economics </li>
//   <li>Hindi/French</li>
//   <li>Biology/ Business Studies</li>
//   <li>Physics/EVM</li>
//   <li>Chemistry/Art and Design</li>
// </ol>
//    <br/>
//    <h5 className='cam-title-heading'><b>GRADING SYSTEM:</b></h5>
//    <p><b>Lower</b>Cambridge Students from grade 6 to 8 are awarded both marks and grade as per Cambridge International, UK. Grade Descriptors are as follows:</p>
//    <br/>
//    <div className='cam-lower-table policy'>
//      <table>
//        <thead>
//          <tr>
//            <th>
//             <p><b>GRADE DISCRIPTOR</b></p>
//             </th>
//            <th>
//             <p><b>MARKS RANGE</b></p>
//             </th>
//          </tr>
//        </thead>
//        <tbody>
//          <tr>
//            <td>
//             <p><b>A*</b></p>
//            </td>
//            <td>
//            <p><b>91-100</b></p>
//            </td>
//          </tr>
//          <tr>
//            <td>
//             <p><b>A</b></p>
//            </td>
//            <td>
//            <p><b>81-90</b></p>
//            </td>
//          </tr>
//          <tr>
//            <td>
//             <p><b>B</b></p>
//            </td>
//            <td>
//            <p><b>71-80</b></p>
//            </td>
//          </tr>
//          <tr>
//          <td>
//             <p><b>C</b></p>
//            </td>
//            <td>
//            <p><b>61-70</b></p>
//            </td>

//          </tr>
//          <tr>
//          <td>
//             <p><b>D</b></p>
//            </td>
//            <td>
//            <p><b>51-60</b></p>
//            </td>
//          </tr>
//          <tr>
//          <td>
//             <p><b>E</b></p>
//            </td>
//            <td>
//            <p><b>41-50</b></p>
//            </td>
//          </tr>
//          <tr>
//          <td>
//             <p><b>F</b></p>
//            </td>
//            <td>
//            <p><b>31-40</b></p>
//            </td>
//          </tr>
//          <tr>
//          <td>
//             <p><b>U</b></p>
//            </td>
//            <td>
//            <p><b>30 & BELOW</b></p>
//            </td>
//          </tr>
//         </tbody>
//              </table>
//              </div> 
// <br/>
// <h5 className='cam-title-heading'><b>Classes XI – XII (IBDP) Grading Criteria (IBDP) </b></h5>
// <p>All IB courses, High Level and Standard Level, are graded on the IB 7-point scale.</p>
// <p><b>7-Excellent Performance: </b> Thorough understanding of the concept, knowledge and skills, ability to apply faultlessly, demonstrates originality, evidence of analysis, synthesis, and evaluation where appropriate and produces work of high quality. </p>
// <br/>
// <p><b>6-Very Good Performance:</b> Thorough understanding of the concept, knowledge and skills, ability to apply them, generally demonstrates evidence of analysis, synthesis, and evaluation where appropriate.</p>
// <br/>
// <p><b>5-Good Performance:</b> A sound understanding of the concept, knowledge and skills, ability to apply them, generally shows evidence of analysis, synthesis, and evaluation and occasionally demonstrates originality and insight.</p>
//  <br/>
// <p><b>4-Satisfactory Performance: </b> A good general understanding of the concept, knowledge and skills, ability to apply them effectively in normal situations. There is occasional evidence of the skill analysis, synthesis, and evaluation.</p>
// <br/>
// <p><b>3-Mediocre Performance:</b> Limited achievements against most of the objectives, or clear difficulties in some areas. The student demonstrates a limited understanding of the concept, knowledge and skills and is only able to apply them fully in normal situations with support.</p>
// <br/>
// <p><b>2-Poor Performance:</b> Very limited achievements of all the objectives. The student has difficulty in understanding of the concept, knowledge and skills and is unable to apply them fully in normal situations even with support.</p>
// <br/>
// <p><b>1-Very poor:</b> Minimal achievement in terms of objectives.</p>
// <br/>
// <h5 className='cam-title-heading'><b>Assessment Criteria:</b></h5>
// <ul className='admission-class'>
//   <li>Student performance is evaluated based on the objectives of each subject. Assessment may be internal or external. Internal assessment will usually contribute between 20% to 30% of the total marks. However, in some Arts courses it may account for almost 50% of the total marks.</li>
// <li>Internal assessment is collaboratively created at the start of DP-I. The same to be spread over a period of two years to avoid overburdening of the student. Parents to receive a copy of the same in order to involve them in the development of their child and to enable them to understand IB better.</li>
// <li>Internal assessment will address those aspects of student's development and training which are not evaluated in the Final IB DP evaluation. It would focus on abilities that are not a part of the academic content.</li>
// <li>There will be at least two assessments conducted every month out of 20 marks that may include either or both Formative and Summative assessments. The marks obtained by students in four assessments conducted over two months will be recorded and converted into grades.</li>
// <li>Students will be evaluated on their punctuality to class and school, their attendance record, and completion of work on time with an appropriate standard. In all courses, students must complete mandatory coursework assignments; typically this coursework amounts to 25% of the final grade for each course, although, in some cases it may be higher or lower. The key to doing this work to an acceptable standard is organization.</li>
// <li>There is a maximum of 7 points available for each of the six required elective courses; in addition, there are 3 points available for a combination of TOK and the Extended Essay. This makes a maximum total of 45 points. A minimum of three subjects must be at the Higher Level.</li>
// <li>Numeric grades have been awarded in all six subjects registered for the IB Diploma</li>
// </ul>
// <br/>
// <h5 className='cam-title-heading'><b>Conditions for achieving the diploma</b></h5>
// <p>A candidate can only receive an IB Diploma if the following conditions are met.</p>
// <ul className='admission-class'>
//   <li>CAS requirements are met.</li>
//   <li>The candidate has achieved at least 24 total points.</li>
//   <li>A grade has been awarded in all subjects, TOK and the EE.</li>
//   <li>A grade of at least a 2 has been awarded in all subjects.</li>
//   <li>There are no more than two grade 2s awarded (SL or HL).</li>
//   <li>There are no more than three grade 3s or below awarded (SL or HL).</li>
//   <li>The candidate has at least 12 points on HL subjects. (For candidates who register for four HL subjects, the three highest grades count).</li>
//   <li>Candidates have at least 9 points on SL subjects. (Candidates who register for two SL subjects must be awarded at least 5 points at SL).</li>
//   </ul>
// <p style={{color:'red'}}><b>To participate as a diploma candidate, the IB student must fulfill the following requirements starting in the 11th grade:</b></p>
// <ul className='admission-class'>
//   <li>Enroll in six IB subjects over 2 years. (Subjects are divided into "Groups" and students must take an exam in each of the subject groups).</li>
//     <li>Write an original essay (called the Extended Essay) of approximately 4000 words.</li>
//     <li>Take the Theory of Knowledge class for two years.</li>
//     <li>Participate in C.A.S. (Creativity, Activity, and Service) and complete a portfolio thats hows Learning Outcomes have been met.</li>
// </ul>
// <br/>
// <h5 className='cam-title-heading'><b>Internal and External Assessment</b></h5>
// <p>Internal Assessment Timeline is collaboratively designed and circulated in the beginning of Grade II to reduce the burden of work and the Internal Assessments are spread over 18months. Assessment is mostly formative (projects, presentations, quizzes, etc.) and summative where ever necessary. All assessments are marked according to the grade descriptors and grade boundaries published by the IB.</p>
// <br/>

// <h5 className='cam-title-heading'><b>Internal Moderation and Quality Checks</b></h5>
// <ul className='admission-class'>
//   <li>To ensure fairness, reliability, and alignment with IB standards, the school follows a system of internal moderation.</li>
//   <li>Samples of internally assessed work from each subject are cross-checked by the DP
// Coordinator to verify consistency in marking.</li>
// <li>Moderation meetings are held after major internal assessments to review marking practices,
// ensure that assessment criteria are applied correctly, and address any discrepancies in awarded
// marks.</li>
// <li>This process ensures that students receive a true reflection of the marks they are likely to
// achieve when work is externally moderated by the IB.</li>
// <li>Feedback from moderation is documented and shared with teachers to improve assessment
// practices in future tasks.</li>
// </ul>

// <h5 className='cam-title-heading'><b>Internal Standardization Practices</b></h5>
// <ul className='admission-class'>
//   <li>Internal standardization is carried out at the beginning of each academic year and prior to
// submission of major internal assessments.</li>
// <li>Teacher review student work, apply IB mark schemes, and compare awarded marks until a
// consensus is reached.</li>
// <li>Standardization sessions include reviewing exemplar student responses from the IB, analyzing
// grade boundaries, and aligning teacher judgments with international expectations.</li>
// <li>As only one teacher teaches a subject, standardization is carried out with support from the DP
// Coordinator and by referencing IB exemplars and teacher support materials.</li>
// <li>The purpose of this process is to maintain equity and consistency in assessment practices
// across all classes and subjects, ensuring that no student is disadvantaged.</li>
// <li>meetings are maintained as evidence of the school’s commitment
// to academic integrity and quality assurance.</li>

// </ul>
// <br/>

// <h5 className='cam-title-heading'><b>School Examinations</b></h5>
// <p>Any attempts to collude, cheat and carry unauthorized material will result in no grade being awarded. The students give two examinations every year, at the end of each semester of the school year and the results of these examinations are recorded and shared with students and parents. The examinations are conducted like mock IB Diploma exams following the same
// pattern and mark schemes.</p>
// <br/>
// <h5 className='cam-title-heading'><b>Academic Integrity</b></h5>
// <p>At the beginning of the session students are made aware of the school’s Academic Integrity Policy. If a student is found guilty of academic misconduct, he/she will not be awarded grade.</p>
// <p>The student will be penalized in case of any plagiarism, collusion or duplication in all internal and external assessments.</p>
// <br/>
// <h5 className='cam-title-heading'><b>Assessment will include a wide variety of tasks such as:</b></h5>
// <ul className='admission-class'>
// <li>A written test, oral tests, group discussions and / Socratic seminars, Data and / or document-based questions, Essays, Experiments, Original research Group and individual oral presentations, reflection of team work in assignments.</li>
// <li>Original research in Group 4 and 3 subjects, oral comments arising in Languages, Projects involving investigation, Multimedia presentations, MCQs, Case Studies, Portfolios, Problem solving and collaborative Science project.</li>
// <li>Projects related to Group 3 subjects, Reflection log, Response journals, Film and Visual Arts work and projects, Documentaries, Art files.</li>
// <li>Activities related to Languages such as Drama, Role plays, etc.</li>
// <br />
// <p>Marking schemes in each unit of DP for every DP subject have been framed by the subject facilitators as per the objectives and learner profile attributes identified for each formative assessment.</p>
// </ul>
// <br/>
// <h5 className='cam-title-heading'><b>Each component of the marking scheme is assessed by awarding grades/marks on different skills developed during the teaching-learning process. The components are as follows:</b></h5>
// <br/>
// <ul className='admission-class'>
//   <li><p><b>Observations: </b> All students are regularly monitored, individually and/ or as a group, throughout the program regarding attentiveness in class, regularity, commitment, the ability to learn from one's mistakes and assessment by peers.</p></li>
// <li><p><b>International mindedness:</b> World issues including racism, economic depression, gender bias, cultural diversity, pollution, population, etc. are researched and discussed with and amongst students and form an essential part of their assignments in CAS and TOK.</p></li>
// <li><p><b>Examples of student’s work or performances: </b> These include performance in formative and summative examinations, class activities, essays, reports and articles.</p></li>
// <li><p><b>Inter-disciplinary skills: </b>The students are evaluated on their original research work, ability to think and reason logically, communicative skills, time and self- management.</p></li>
// <li><p><b>Learner Profile Attributes: </b> Students are assessed on the learner profile attributes.</p></li>
// <li><p><b>Open-Ended questions: </b> Students are encouraged to produce original ideas for class discussions.</p></li>
// <li><p><b>Quizzes: </b>May be used to assess learning and acquired knowledge of specific data by each student. </p></li>
// <li><p><b>Portfolio: </b> Students need to maintain a folder containing copies of all work done by them during DP-1 and DP-2 with reflections on how they have grown as individuals and what they have achieved.</p></li>
// </ul>
// <br/>
// <h5 className='cam-title-heading'><b>Assessment Details:</b></h5>
// <p>The assessment pattern entails two Summative (Terminal examinations), one in September and the other in March. The Summative will be supplemented by class tests; class activities, project works and oral assignments in languages. However, in standard 12 apart from the formative and Summative test 1, there are two Pre-Board Examinations/Mock Drills in order to prepare the students for the formal Board Examination. The Mock Drill is organized and scheduled in such a way that students get the complete feel of the actual IB exams and are well aware of the rules and regulations to be followed.</p>
// <br/>
// <h5 className='cam-title-heading'><b>Reporting:</b></h5>
// <p>At the end of each semester exam, report cards are issued to the parents. The mock/pre
// board of IBDP Year-2 students are also assessed and reported to the parents. Each component is evaluated strictly in adherence with the assessment criteria provided by the IB. The students are given comprehensive feedback about their level of achievement as per each grade description.</p>
// <br/>
// <h5 className='cam-title-heading'><b>Home Work:</b></h5>
// <p>Students are given homework tasks every day and a sufficient amount of time to complete it. A student is required to put in two hours of work at home regularly. On weekends projects are given which should be submitted on the following Monday. Students who fail to complete their homework are given 3 warnings after which they are detained in school and their parents are informed about their irregularity and inconsistency in work. Teachers ensure that all work/project is the original work of the students and not copied from any source.</p><br/>
// <h5 className='cam-title-heading'><b>Predicted Grade Policy</b></h5>
// <p>The teacher awards predicted grades on the basis of Summative and Formative Assessments such as class participation, presentation, discussion, and class test and semesterexams.</p>

// <p>The teachers are asked to award predicted grades thrice so that they are able to assess the students and also obtain accuracy in the process. The teachers award predicted grades for each student, before the final semester exam of Year 1(March), then after the first term exams of Year 2 (September) and finally in March of Year 2.</p>
// <br/>
// <h5 className='cam-title-heading'><b>Non-submission of Internally and Externally assessed components</b></h5>
// <p>Prior to the approach of internal deadlines, in the event a student is lagging behind, the subject teachers warn him of severe consequences of non-submission.</p>
// <br/>
// <p>In case the student still does not submit and the deadline is approaching, the DP Coordinator and the parents are informed.</p>
// <br/>
// <p>The school community reviews and amends the assessment policy at the beginning of every session. The assessment policy review meeting is attended by the Head of School, Vice Principal, IBDP Coordinator, IBPYP Coordinator, IGCSE Coordinator,Librarian, Subject teachers and representatives, parents and student community.</p>
// <br/> 
// <h5 className='cam-title-heading'><b>Steering Committee</b></h5>
// <p>Sanskar School Assessment Policy steering committee comprises of – Principal</p>
// <ul className='admission-class'>
//   <li>Vice Principal</li>
//   <li>DP Coordinator</li>
//   <li>PYP Coordinator</li>
//   <li>IGCSE Coordinator</li>
//   <li>CBSE Coordinators</li>
//   <li>Section Coordinators</li>
//   <li>2 Facilitators per Programme</li>
//   <li>2 Parent Representatives</li>
// </ul>
// <br/>
// <p>It is the responsibility of the committee to oversee the procedures needed to develop the Assessment Policy of the School, communicate the same to all the stakeholders and ensure that the process of compilation and review is collaborative and involving all, using a range of strategies.</p>
// <br/>
// <p>As with other policies and processes, this policy has been drafted with inputs from various sections of the School community and shall be reviewed and shared with all the stakeholders of the school.</p>
// <br/>
// <h5 className='cam-title-heading'><b>Assessment Policy Review</b></h5>
// <p>Assessment Policy will be reviewed by the Steering Committee at the beginning of every academic year. The effectiveness of the Assessment Policy as a working document will be reviewed with the help of collaborative discussions and meetings.</p>
// <br/>
// <h5 className='cam-title-heading'><b>Communicating the policy to various stake holders through: </b></h5>
// <ol className='admission-class' type='1'>
//     <li>Provision of hardcopies of the policy.</li>
//     <li>The official school website.</li>
//     <li>Electronic mails.</li>
// </ol>
// <br/>
// <h5 className='cam-title-heading'><b>References:</b></h5>
// <p>Candidates with assessment access requirements by International Baccalaureate Organization 2009, updated September 2013.</p>
// <p>Academic honesty by International Baccalaureate Organization2009, updated July2011. Program Standards and Practices by International Baccalaureate Organization 2009, published January 2014.</p>
// <p>Handbook of procedures for the diploma programme 2015 by International Baccalaureate Organization 2009.</p>
// <p>Central Board of secondary Education Assessment guidelines 2017.</p>
// <br/>
// <ul className='admission-class'>
//   <li>Approved by consensus of the faculty in March, 2015.</li>
//   <li>Revised by the school in April, 2016</li>
//   <li>Revised by the school in April, 2017.</li>
//   <li>Revised by the school in April, 2018.</li>
//   <li>Revised by the school in April, 2019.</li>
//   <li>Revised by the school in May, 2020.</li>
//   <li>Revised by the school in September, 2021.</li>
//   <li>Revised by the school in May, 2022.</li>
//   <li>Revised by the school in June, 2023.</li>
//   <li>Revised by the school in June, 2024.</li>
//   <li>Revised by the school in March, 2025.</li>
// </ul>
// <br/>
// <div style={{textAlign: "center"}}>
// <h5 className='cam-title-heading'><b>SANSKAR SCHOOL</b></h5>
// <h5 className='cam-title-heading'><b>ESSENTIAL AGREEMENT FOR ASSESSMENT</b></h5>
// </div>
// <br/>
// <p><b>The faculty at Sanskar School agrees:</b></p>
// <ul className='admission-class'>
//   <li>to use a range of Assessment strategies and tools.</li>
//   <li>to use assessments as feedback to improve learning.</li>
//   <li>to record and report student progress as per the Assessment Policy.</li>
// </ul>
// <br/>
// {/* <div style={{textAlign: "center"}}>
// <h5 className='cam-title-heading'><b>APPENDIX</b></h5>
// </div>
// <br /><br /><br />
// <p>I, __________________________________________________________________, student of Sanskar School studying in Grade ____________________, hereby undertake to abide by the terms mentioned in the
// Assessment Policy.

// </p>
   
//   <ul className='from-sign'>
//     <li ><span>Signature of the student</span> <span>Signature of the parent</span></li>
//   </ul>
//   <p>Date:</p> */}
//      </div>



//     </div>},
    { title: 'Academic Integrity Policy', content: () => <div>

<div className='cam-lower-sec'>
    <h1 className='title'>Academic Integrity Policy</h1>
    </div>


    <div className='newsletter-sec-row'>
          <div className='newletter-box'>
            <Link to="../policy/Academic-Integrity-Policy.pdf"
              target="_blank"
              rel="noopener noreferrer"> 
            <div className='newletter-img'>
              <img src="../policy/Academic-Integrity-Policy.webp" alt="" />
            </div>
            <div className='newsletter-heading'>
              <p>Academic Integrity Policy </p>
          
            </div>
            </Link>
          </div>
       </div>

</div>
        

   },
    { title: 'College Counselling Policy', content: () => 
    
      <div>

      <div className='cam-lower-sec'>
          <h1 className='title'>College Counselling Policy</h1>
      </div>

       <div className='newsletter-sec-row'>
          <div className='newletter-box'>
            <Link to="../policy/College-Counselling-Policy-2026.pdf"
              target="_blank"
              rel="noopener noreferrer"> 
            <div className='newletter-img'>
              <img src="../policy/College-Counselling-Policy-2026.webp "alt="" />
            </div>
            <div className='newsletter-heading'>
              <p>College Counselling Policy</p>
          
            </div>
            </Link>
          </div>
       </div>

      </div>
    
    },
//     {title: 'Language Policy', content: () => <div>

// <div className='cam-lower-sec'>
//     <h1 className='title'>Language Policy</h1>
    
//       <h5 className='cam-title-heading'>Sanskar School aims to:</h5>
//       <ul>
//           <li>equip its pupils with a <b>critical and global outlook </b>which will make them committed citizens of the world.</li>
//           <li>recognize and channelize the potential of the pupil and develop thinking, communication, social, scientific and interpersonal skills.</li>
//           <li>Foster <b>cognitive, affective and psychomotor development</b> and enable the pupil to make connections with the acquired knowledge in his/her everyday life.</li>
//         </ul>

//         <h5 className='cam-title-heading'><b>Philosophy:</b></h5>
//         <p>Sanskar School believes that language is a vital medium for learning, communication and expression. Language is fundamental to all teaching and learning and permeates the entire curriculum. Through language we promote inter cultural awareness, sharing and respecting different perspective and accepting diversity.
// </p>
// <h5 className='cam-title-heading'><b>Objective:</b></h5>
// <p>The language policy endeavors to consolidate the philosophy and beliefs at Sanskar School
// with respect to imparting linguistic education to students.</p>
// <p>Sanskar language philosophy grooms the students for an intercultural world and prepares
// them to adapt the varied cultural environments of the world. It includes the interests of the
// entire community and takes into account the needs of the students. The philosophy highlights are:</p>

// <ol className='admission-class' type='1'>
//   <li>Language forms the basis of all information and learning.</li>
//   <li>Language learning is a lifelong process and plays an integral role in intellectual
//   development. Skill acquired in one language can be transferred to other languages.</li>
//   <li>Proficiency in the language of instruction helps the students to acquire competence in other academic areas.</li>
//   <li>Language is a part of the student's identity and expresses one’s tradition, culture and values.</li>
//   <li>Language skills foster international mindedness by viewing things from a
//   multicultural perspective.</li>
//   <li>Teaching learning process will take into account the language needs of the students.</li>
//   <li>All teachers are language teachers.</li>
//   <p>The language policy document aims to outline systems and strategies to support the
// development of English language as well as to advance and uphold the use of mother tongue in the community.</p>
// <p>The document will support any planning and implementation of language teaching,
// curriculum planning and professional development.</p>
// </ol>
// <h5 className='cam-title-heading'><b>Introduction:</b></h5>
// <p>Study of language provides insight and understanding of other cultures and the ability to
// read, write and speak in more than one language empowers the student with communicative
// skills and higher order thinking skills.</p>
// <p>English is the language of instruction at Sanskar School. It is a language other than their
// mother tongue. Students will need to acquire English not only to access the curriculum but
// also to participate in the cultural and social life at school.
// </p>
// <p>English is the school’s internal working language, in which all operational and development
// activities take place. It is also the language of its governance, management and academic
// communities.</p>
// <p>The school believes that the contribution of parents, students, teachers and the wider society will go a long way in developing a caring language community and confident language
// learners.</p>
// <p>The school believes that multilingualism enhances the personality, cognitive functions and
// academic abilities of the child. It enriches cultural understanding and provides a global
// dimension to learning.</p>

// <h5 className='cam-title-heading'><b>AIMS AT SANSKAR TO ENHANCE LANGUAGE PROFICIENCY:</b></h5>

// <ol className='admission-class' type='1'>
//   <li><h5 className='cam-title-heading'><b>Enable students to learn and use language effectively, appropriately, accurately and confidently:
// </b></h5> </li>
// <p>To fulfil the above aim, the school uses different language teaching techniques
// including interaction, conversation, role play, dramatization, group discussions,
// elocution, recitation, debates, speeches, Just a Minute, etc. as a part of the regular
// teaching and learning process right from the Pre-Primary level. These enable the
// students to communicate efficiently, increase their vocabulary and gain confidence
// while speaking the language.</p>
// <p>The use of the dictionary is encouraged at all levels and activities including spell bee, word puzzles and word games are used to increase vocabulary</p>
// <p>Students are also encouraged to speak only in English, and positive motivation in the
// form of words of praise and commendations are used. Teachers model appropriate
// behaviour by using English as a mode of communication in and out of the classes.</p>

// <li><h5 className='cam-title-heading'><b>Develop student's power of oral & written communication:</b></h5></li>
// <p>Language learning at the very early stages uses phonetics to lay a sound foundation.
// The activities mentioned above help to improve oral communication. Written
// communication starts from the learning of the alphabet at the Pre-primary level and
// continues with the introduction of picture descriptions, paragraph writing, dialogue
// completion in Primary classes to article writing, essay writing, notices, letters,
// dialogues, e-mails, booklets, blogs, etc. in higher classes. Students become adept at
// expressing themselves accurately and confidently.
// </p>
// <p>In addition to the activities mentioned above written assignments help students to
// develop their skills and written communication. Article writing, essay writing, report
// writing, notices, letters, dialogues, e-mails, blogs, booklets etc. form part of the
// language syllabus of the students. School encourage and appreciate creative writing of students by publishing in School Magazine.</p>
// <p>Students are also motivated to read for pleasure and develop their own individual
// writing style. News Paper reading and reading of a variety of magazines available in
// the school library make students aware of current issues nationally and internationally
// while enhancing their personality.</p>
// <li><h5 className='cam-title-heading'><b>Develop testing skills in students:</b></h5></li>
// <p>Most students not only speak and write correctly and accurately but are constantly
// enhancing their communication skills. Students are encouraged to evaluate their
// progress through regular assessments, assignments, tests and examinations. Participation in group learning activities is encouraged where students simultaneously assess their learning and at the same time improve their skills.</p>
// <p>The school also records audio pieces of students that they may hear again and then
// work upon their pronunciation and grammar. Assessment of speaking and listening
// skills forms a core component of Sanskar’s language policy and passive students are
// given additional attention and counselled to “open up”.</p>
// <li><h5 className='cam-title-heading'><b>Enabling the development and utilization of language in different contexts and purposes:
// </b></h5></li>
// <p>The school in itself is a microcosm of the larger community and social skills form an
// important part of language learning. The school believes in holistic grooming of all
// students and social etiquette and norms become a part of the student's life from a very
// young age.</p>
// <p>The school also provides students with numerous platforms to develop and use their
// language skills including school assemblies, functions, sport meets inter school
// events, etc. Welcoming guests, thanking them, expressing their views at school
// council meetings are all opportunities that come to students during their school life.
// At Sanskar, inter-school, state-level and regional- level competitions are given
// priority to expose students to the world of ‘language’ as used and articulated by
// others.
// </p>

// <li><h5 className='cam-title-heading'><b>Promote the appreciation, understanding and analysis of literature:</b></h5></li>
// <p>From kindergarten itself, story-telling, story reading, reading of texts and reading for
// pleasure form an essential part of the curriculum. Children are motivated to read for
// the joy that it brings and understand and analyse the writing and make connections
// with the context in which the writing has been done. </p>
// <p>The library is a rich resource from where students may issue books for a week and
// read them at leisure. Sanskar sending students to cultural fests, such as the Jaipur
// Literature Festival, is one way of initiating students to the rich and wide world of
// literature and language. To go further to strengthen the command on language, books
// as prizes are given to students to inculcate reading habit and develop rich language
// skills.</p>

// <li><h5 className='cam-title-heading'><b>Understand the vocabulary and terms used in different subject areas:</b></h5></li>
// <p>Each subject has its own vocabulary and technical terms which are explained to
// students depending on the level at which they are studying. Practicals are conducted
// where required to make this understanding life-long.</p>

// <li><h5 className='cam-title-heading'><b>Encourage students to experiment and research the use of language as an expression of the diverse perspectives of people belonging to different cultures:</b></h5>
// <p>Literature is representative of the culture in which it is born, and the variety of
// books read by the child determines his/her understanding of varied cultures and
// people. To improve intercultural understanding learning different languages is an
// important step. Students of Sanskar School have the opportunity to learn English,
// Hindi, Sanskrit and French. Teaching of French starts from Grade 4 & teaching of
// Sanskrit and French starts from Std. VI. </p>
// </li>
// </ol>
// <br/>
// <h5 className='cam-title-heading'><b>School Language Profile</b></h5>
// <p>At Sanskar School, 99% of the students come from families where their language
// spoken at home is Hindi, Rajasthani, Punjabi, Bengali or some other regional
// language. However, English is the medium of instruction and is commonly acceptable
// to all.</p>
// <p>Sanskar School encourages multi-lingual learning amongst students. English forms the
// medium of education/teaching and the school’s official language. It is also the language
// used for governance, management and by the academic committees. </p>
// <br/>
// <h5 className='cam-title-heading'><b>Language path from Pre-Primary to grade XII:</b></h5>
// <h5 className='cam-title-heading'><b>Pre-Primary to Grade V </b></h5>
// <p>Sanskar School recognizes language as a pivotal aid in the process of learning. In order to
// promote inquiry-based language learning all teachers are responsible for development of language skills.</p>

// <p>Teaching and learning of language is incorporated throughout the trans-disciplinary
// program of inquiry. The language curriculum is framed within the framework and promotes the development of skills of listening, speaking, reading, writing and media literacy. Exhibitions and class shows are organized annually to provide exposure to students in English/Hindi language.</p>

// <p>The school’s policy along with the inclusion of second language teaching and mother tongue language support aims to meet the development needs of students and reflects the principles of the programme.</p>

// <p>The language of instruction at school is English. It has precedence in the school’s language curriculum. English is used in school publications, on the website, on signage, in communication between school and the parent community as well as among members of the staff. </p>

// <p>The school promotes the development of Hindi as an additional language Hindi is also the mother tongue for many and a common language of communication in the family, community and society. The skills of listening, speaking, reading, writing and media
// literacy in the additional language are developed by teachers engaged specially in the
// teaching and learning of the additional language.</p>

// <p>Language skills are integrated with Units of inquiry. There are fixed times in the schedule to learn the host country language, and the second language – in this case Hindi Support of mother-tongue development is through activities based on phonics, symbols, reading, writing, reading books in mother tongue, sharing stories through translation and vocabulary building exercises. We promote enrichment of the mother tongue by encouraging families to continue speaking, reading and writing the language at home. Sanskar School celebrates International Mother Language Day, where the parents are invited to share interesting facts, poetry, stories and much more about the language they speak.
// </p>

// <p>The teachers at Sanskar School meet the differentiated learning needs and use a structured and planned framework of instruction of language to all students. This approach is aimed at helping our students attain essential language skills – reading, writing, listening, speaking, viewing and presenting.</p>

// <p>Students who are not proficient in the language of instruction and additional language are provided additional support through guided learning by the teacher after class, during zero periods or in the learning center as considered appropriate. The decision to provide this support is taken only after due consultation with the teacher and the parent of the child.</p>

// <br/>

// <h5 className='cam-title-heading'><b>Grade VI to XII</b></h5>
// <p>Teaching of the English language continues across all levels up to grade 12. The second language is Hindi, which is the mother tongue for most of the students and is taught across all levels up to grade 10 to encourage students to continue with various activities like speaking, book review, slogan writing, book cover design, reading and writing the language.</p>

// <p>Mother-tongue development is further encouraged by our Language Club which is
// organized twice in an academic year. Clubs related to various languages are formed and
// learners enjoy being part of their Mother-tongue club supported by the parent community.
// Learners enjoy wide range of learning experiences in their mother tongue like numbers,
// rhymes, stories, names of fruits, vegetables, animals by being part of the club.</p>

// <p>The third language in classes 6 to 8 includes Sanskrit and French to foster a deep
// understanding and to develop a love and appreciation for literature. In classes 9 and 10
// students can opt for either Hindi or Sanskrit as second language.</p>

// <p>The language teaching at every level takes in account the prior knowledge of the students and enhances their understanding and appreciation of the language at each successive grade.</p>

// <p>Sanskar School recognizes that language is fundamental to all learning processes as
// it permeates the entire curriculum. The school strives to improve the mother tongue,
// international language and language of instruction.</p>

// <br/>
// {/* <h5 className='cam-title-heading'><b>Grade VI to X (IGCSE)</b></h5>
// <p>Teaching of the English language continues across all levels up to grade 10. The
// second language is Hindi, which is the mother tongue for most of the students and is taught across all levels up to grade 10 to encourage students to continue speaking, listening, reading and writing the language. </p>

// <p>The third language in classes 6 to 10 is French to foster a deep understanding and to
// develop a love and appreciation for literature. In classes 9 and 10 students can opt for either Hindi or French as second language. The language teaching at every level takes in account the prior knowledge of the students and enhances their understanding and appreciation of the language at each successive grade.</p>

// <p>Sanskar School recognizes that language is fundamental to all learning processes as
// it permeates the entire curriculum. The school strives to improve the mother tongue,
// international language and language of instruction.</p>


// <br/>
// <h5 className='cam-title-heading'><b>Grade XI and XII IBDP</b></h5>
// <p>IBDP candidates must meet the standard of fluency that enables them to ‘think’ in English. The candidates must, therefore, be successful in spontaneously ‘decoding’ (in the mind) auditory and visual stimuli in English competently as per IB guidelines.</p>

// <h5 className='cam-title-heading'><b>Language competencies required for IBDP candidates:</b></h5>
// <ol className='admission-class' type='1'>
//   <li>Ability to ‘think’ in English.</li>
//   <li>Ability to analyse and process thoughts clearly.</li>
//   <li>Ability to write a structured article expressing one’s own ideas, perspectives and
// original research cohesively.</li>
// <li>Ability of the candidate to maintain the written record of academic effort, punctuality,
// pro-activeness and discipline shown by him during the program.</li>
// <p>Learning a language improves transcultural understanding and students become more
// sensitive to diverse cultural perspectives, appreciating diversity and respecting it. Thus intensive language learning is a significant goal of the program.</p>
// <p>Norms and standards for IB Diploma program in accordance with IB guidelines Standards
// and recommendations is created to determine a positive learning experience for IB DP
// English Language study.</p>
// </ol>
// <br/>
// <h5 className='cam-title-heading'><b>Group-1 Language and Literature:</b></h5>
// <p>Group 1 is a literature and language course in English/Hindi, which is the first language of the student.</p>
// <ol className='admission-class' type='1'>
//   <li>English/Hindi is the language used for teaching and learning in the school, and
//   students have been communicating in this language from the start of their schooling.</li>
//   <li>The option of English/Hindi HL is available to students who plan to continue post – secondary study in English Literature and Language.</li>
//   <li>The SL option is more appropriate for students who plan to choose three other HL
//   subjects or are not very comfortable in Literature and Language.</li>
//   <p>The English/Hindi Literature and Language SL&HL Courses offered in Group 1 include
// some translated works not originally written in English/Hindi. These readings provide
// students with the opportunity to understand and empathize with different cross-cultural
// perspectives with written assignments on the same, and help them in developing an
// appreciation of world literature.</p>
// </ol>

// <br/>

// <h5 className='cam-title-heading'><b>Group-2 Language B:</b></h5>
// <p>The school offers French ab initio, French HL/SL, Hindi HL/SL.These languages are studied in context of the culture and actual setting. Evaluation includes awareness of the culture whose language is being studied.</p>

// <h5 className='cam-title-heading'><b>Group 3, 4, 5 and 6 subjects:</b></h5>
// <p>Every subject has its own language including terms that are subject specific, technical and computer related. All candidates are taught terms specific to a subject and they are also allowed the use of a dictionary for translation, as required, as per IB guidelines.
// </p>

// <h5 className='cam-title-heading'><b>Support for Mother Tongue:</b></h5>
// <p>Sanskar School appreciates a large cohort of regional languages spoken by the school
// community and offers advice and support to students who wish to include their mother
// tongue in their subject program. Literature and Language HL/SL may be studied as a school supported self- taught subject with the following conditions mentioned below:
// </p>

// <ul className='admission-class' >
//   <li>The school offers assistance to such candidates in searching for a suitable tutor / teacher for the mother tongue who in turn is expected to inform the DP Coordinator regarding the development of the candidate on a regular basis.</li>
//   <li>A detailed report needs to be submitted to the DP Coordinator by the appointed
// teacher, with comments on the development of the candidate, at least four times in a
// year</li>
// <li>The school may consider a request for provision of classroom space to teach such a
// candidate, if space is available and the governing body has approved the same. Any
// remuneration to be paid to the teacher is borne by the parents /guardians and is their
// sole responsibility</li>
// </ul>
// <br />
// <br /> */}
// <h5 className='cam-title-heading'> <b><u>Assessment</u></b></h5>
// <p>Assessment of the language development is based on the objectives of teaching and learning. The assessment of language is conducted in the areas of-</p>

// <p><u><b>Oral communication-</b></u> includes speaking and listening, Viva on project file (Grade XI and XII)</p>

// <p><u><b>Visual communication-</b></u> includes processing and conveyance of ideas in forms that can be seen</p>

// <p><u><b>Written language-</b></u> entails reading and writing</p>

// <p>Identification of strengths and weaknesses in the different areas of knowledge is done through classroom observation, written assignments, projects, and tests. Assessment of language is a continuous process and the development of language skills is reported regularly to parents during open house sessions. Written reports of progress are provided twice a year-once at the end of each semester.</p>
// <br/>

// <h5 className='cam-title-heading'><b>Library Resources</b></h5>

// <p><b>Today a reader, tomorrow a leader – Margaret Fuller</b></p>

// <p>Sanskar School recognizes that the library is fundamental to our language programme. It provides a learning space, an environment to promote love for reading books, and is a
// valuable source for academic research</p>

// <p>The library has a collection of over 15,050 books including picture books, fiction, nonfiction, world classics, autobiographies, encyclopedias, dictionaries, multicultural books, reference books, art, activity and puzzle books, and teachers’ resource books from variety of publications. The books are in English, Hindi, French and as well as Regional Languages (Bilingual). The library subscribes to all leading newspapers and magazines in English as well as Hindi. The school sees the library as a valuable resource to promote international mindedness aspect of the IB programme.</p>

// <p>The library is also seen as a place which makes a strong statement that all languages are celebrated and supported. The school continues to add to its collection of Hindi and multicultural books</p>

// <p>The library provides resources for collaborative planning, researching and teacher
// professional development. Our school board is aware of the need to expand these resources and we plan to continually add to the same</p>

// <p>Right from grade I to grade XII students issue books of their choice. Teachers also conduct classes in the library with prior information. Book discussions, read-aloud time, story-telling sessions and guided academic research is conducted in the library on a regular basis.</p>


// <h5 className='cam-title-heading'><b>Steering Committee</b></h5>
// <p>Sanskar School Language Policy steering committee comprises of: -</p>

// <ul className='admission-class' >
//   <li>Head of School</li>
//   <li>Vice Principal of School</li>
//   <li>IBDP Coordinator</li>
//   <li>IBPYP Coordinator</li>
//   <li>IGCSE Coordinator</li>
//   <li>CBSE Coordinators</li>
//   <li>Section Coordinators</li>
//   <li>2 Facilitators per Programme</li>
//   <li>2 Parent Representatives</li>
//   <li>Librarians</li>
// </ul>
// <p>It is the responsibility of the committee to oversee the procedures needed to develop the language philosophy and policy of the school, communicate the same to all the stakeholders and ensure that the process of compilation and review is collaborative and involving all, using a range of strategies.</p>
// <p>As with other policies and processes, this policy has been drafted with inputs from various sections of the school community and shall be reviewed and shared with all the stakeholders of the school.</p>

// <h5 className='cam-title-heading'><b>Language Policy Review</b></h5>

// <p>Support and development of language as part of the school curriculum will be reviewed by the Language Policy Steering Committee at the beginning of every academic year. The level of support can be increased or decreased according to the proficiency level of the students.</p>

// <p>The effectiveness of the language policy as a working document will be reviewed with the help of collaborative discussions and meetings.</p>



// <h5 className='cam-title-heading'><b>Communicating the policy to various stake holders through:</b></h5>

// <ul className='admission-class' >
//   <li>Provision of hardcopies of the policy in library.</li>
//   <li>The official school website.</li>
//   <li>Electronic mails</li>
//   <li>Schools official drive</li>
//   <li>Display in school corridors</li>
//   </ul>


//   <h5 className='cam-title-heading'><b>References:</b></h5>

//   <p>Guidelines for developing a School Language Policy by International
//   BaccalaureateOrganization 2009, published April 2008.</p>
//   <p>Program Standards and Practices by International Baccalaureate Organization 2009,
//   published January 2014.</p>
//   <p>Programme Standards and Practices; International Baccalaureate Organisation;
//   Publish October 2010.</p>
//   <p>Language Scope and Sequence; International Baccalaureate Organisation; Publish February 2009.</p>
//   <p>Handbook of procedures for the diploma programme 2015 by International
// Baccalaureate Organization 2009.</p>


// <h5 className='cam-title-heading'><b>Essential agreement for Language instruction</b></h5>

// <p>The faculty at Sanskar School agrees:</p>

// <ol className='admission-class' type='1'>
//   <li>The language development is the responsibility of every teacher.</li>
//   <li>To support the development of the language instruction (English) and additional
//   language (Hindi).</li>
//   <li>To use differentiated instruction to meet students’ learning needs and styles.</li>
//   <li>To work with all the students to develop and use language skills in a variety of
// contents and purposes.
// </li>
// <li>To help the students to express ideas spontaneously, fluently and precisely.</li>
// </ol>
// <br /><br />
// <p>Approved by consensus of the faculty in May 2015.</p>
// <p>Reviewed and revised by the school in May 2017.</p>

// <p>Reviewed and revised by the school in April 2018.</p>
// <p>Reviewed and revised by the school in April 2019</p>
// <p>Reviewed and revised by the school in January 2020.</p>
// <p>Reviewed and revised by the school in August 2020.</p>
// <p>Reviewed and revised by the school in September 2021. </p>
// <p>Reviewed & revised by the school in August 2022.</p>
// <p>Reviewed & revised by the school in June 2023.</p>
// <p>Reviewed & revised by the school in June 2024. </p>
// <p>Reviewed & revised by the school in June 2025. </p>

// <br />
// {/* <br />

// <h5 className='cam-title-heading'><b>APPENDIX</b></h5>
// <br />
// <br />  
// <p>I, __________________________________________________________________, student of Sanskar School studying in Grade ____________________, hereby undertake to abide by the terms mentioned in the Language Policy.</p>
   
//   <ul className='from-sign'>
//     <li ><span>Signature of the student</span> <span>Signature of the parent</span></li>
//   </ul>
//   <p>Date:</p>

//   <br></br> */}

//         </div>
//         </div>


//     },

    {title: 'Language Policy', content: () => <div>
      <div className='cam-lower-sec'>
    <h1 className='title'>Language Policy</h1>
    </div>

       <div className='newsletter-sec-row'>
          <div className='newletter-box'>
            <Link to="../policy/LANGUAGE-POLICY.pdf"
              target="_blank"
              rel="noopener noreferrer"> 
            <div className='newletter-img'>
              <img src="../policy/LANGUAGE-POLICY.webp" alt="" />
            </div>
            <div className='newsletter-heading'>
              <p>Language Policy</p>
          
            </div>
            </Link>
          </div>
       </div>


        </div>


    },
    {title: 'Inclusive Education Policy', content: () => <div>
      <div className='cam-lower-sec'>
    <h1 className='title'>Inclusive Education Policy</h1>
    </div>

       <div className='newsletter-sec-row'>
          <div className='newletter-box'>
            <Link to="../policy/Inclusive-Education-Policy.pdf"
              target="_blank"
              rel="noopener noreferrer"> 
            <div className='newletter-img'>
              <img src="../policy/Inclusive-Education-Policy.webp" alt="" />
            </div>
            <div className='newsletter-heading'>
              <p>Inclusive Education Policy </p>
          
            </div>
            </Link>
          </div>
       </div>
        </div>


    },

 
        { title: 'Library Policy', content: () => <div>
          <div className='cam-lower-sec'>
    <h1 className='title'>Library Policy</h1>

     
     <div className='newsletter-sec-row'>
          <div className='newletter-box'>
            <Link to="../policy/IB Library Policy.pdf"
              target="_blank"
              rel="noopener noreferrer"> 
            <div className='newletter-img'>
              <img src="../policy/IB Library Policy.webp" alt="" />
            </div>
            <div className='newsletter-heading'>
              <p>Library Policy</p>
          
            </div>
            </Link>
          </div>
       </div>



 </div>
        </div>
          },
    { title: 'Information Technology Resources Policy', content: () => <div>

<div className='cam-lower-sec'>
    <h1 className='title'>School ICT Resources Policy</h1>

     <div className='newsletter-sec-row'>
          <div className='newletter-box'>
            <Link to="../policy/ICT POLICY.pdf"
              target="_blank"
              rel="noopener noreferrer"> 
            <div className='newletter-img'>
              <img src="../policy/ICT POLICY.webp" alt="" />
            </div>
            <div className='newsletter-heading'>
              <p>School ICT Resources Policy</p>
          
            </div>
            </Link>
          </div>
       </div>
    
 

       
</div>

    </div> },
    { title: 'Laboratory Policy', content: () => <div>

<div className='cam-lower-sec'>
    <h1 className='title'>Laboratory Policy</h1>
       </div>

       <div className='newsletter-sec-row'>
          <div className='newletter-box'>
            <Link to="../policy/Laboratory Policy.pdf"
              target="_blank"
              rel="noopener noreferrer"> 
            <div className='newletter-img'>
              <img src="../policy/Laboratory Policy.webp" alt="" />
            </div>
            <div className='newsletter-heading'>
              <p>Laboratory Policy</p>
          
            </div>
            </Link>
          </div>
       </div>
   




    </div> },


{ title: 'School Policy for Predicted Grades', content: () => <div>

  <div className='cam-lower-sec'>
      <h1 className='title'>School Policy for Predicted Grades</h1>
        <h5 className='cam-title-heading'>Sanskar School aims to:</h5>
        <ul class="admission-class">
            <li>equip its pupils with a <b> critical and global outlook </b> which will make them
            committed citizens of the world</li>
            <li><b>recognize and channelize the potential</b> of the pupil and develop thinking, communication, social, scientific and interpersonal skills.</li>
            <li>foster <b> cognitive, affective and psychomotor development </b> and enable the pupil
            to make connections with the acquired knowledge in his/her everyday life.</li>
          </ul>
          <br/>
          <p>The purpose of this policy is to provide a structured framework for facilitators at Sanskar School to ensure accuracy, fairness, and consistency in predicting grades for IBDP students. This policy aims to support students’ university applications with reliable grade predictions while maintaining the integrity of the process.</p>
      <br/>
<h5 class="cam-title-heading"><b>Policy Guidelines:</b></h5>
<ol className='admission-class'>
<li><h5 class="cam-title-heading"> <b>Basis for Predicted Grades:</b></h5></li> 
<ul className='admission-clas'>
  <li>Predicted grades must be based on a thorough evaluation of a student’s academic
  performance throughout their IBDP course. This includes, but is not limited to:</li>
  <li>Results from internal assessments and coursework.</li>
  <li>Mock examinations and Term examinations.</li>
  <li>Class participation and engagement.</li>
  <li>Consistency and improvement in performance over time.</li>
  <li>Teacher observations.</li>
  <li>Facilitators should use a data-driven approach, incorporating historical
performance and relevant trends in student achievement.
</li>
  </ul> 
  <li><h5 class="cam-title-heading"> <b>Predicted Grade Timelines:</b></h5></li>
  <ul className='admission-clas'>
    <li>Facilitators are permitted to provide predicted grades to a student up to three times
    (if required) during IBDP Year 2:</li>
    <ol type='i' className='admission-class'>
      <li>After Term 1: Based on cumulative performance of IBDP Year 1 (Term 1&2) &
      IBDP Year 2 (Term 1) </li>
      <li>After the First Mock Exam: Evaluating results from the first comprehensive
      mock examination.</li>
      <li>After the Third Mock Exam: Following the third and final mock examination,
      considering the student’s overall progress and readiness.</li>
    </ol>
    <li>Each set of predicted grades should reflect the student’s growth, adjustments, and
    learning over time.</li>
    </ul> 

 <li><h5 class="cam-title-heading"> <b>Standardization:</b></h5></li>
 <ul className='admission-clas'>
  <li>To ensure fairness, predicted grades should undergo a standardization process.
Facilitators should discuss predicted grades collaboratively within their subject
teams to maintain consistency and adherence to IB standards.
</li>
<li>Predicted grades must align with past performance trends and data, with any
significant deviations documented and justified.</li>
  </ul>

  <li><h5 class="cam-title-heading"> <b>Confidentiality:</b></h5></li>
  <ul className='admission-clas'>
    <li>All predicted grades must remain confidential until officially communicated to the
    authorized university or admissions body.</li>
    <li>Facilitators should not disclose individual student predictions to students or
    parents prior to formal submission.</li>
    </ul>

    <li><h5 class="cam-title-heading"> <b>Professional Integrity:</b></h5></li>
    <ul className='admission-clas'>
      <li>Facilitators are expected to maintain professional integrity and exercise sound
judgment when predicting grades. This ensures that predictions are realistic,
balancing optimism with caution, to accurately reflect the student’s potential.
</li>
      </ul>
      <li><h5 class="cam-title-heading"> <b>Documentation and Record-Keeping:</b></h5></li>
      <ul className='admission-clas'>
        <li>Facilitators must document the rationale behind each predicted grade. This
includes maintaining records of assessments and significant academic data that
contributed to the prediction.</li>
<li>All documentation should be retained securely and be available for internal review
if required.
</li>
        </ul>

        <li><h5 class="cam-title-heading"> <b>Appeals and Re-Evaluation:</b></h5></li>
        <ul className='admission-clas'>
          <li>If a student or guardian raises a concern regarding the predicted grade, the matter
should be directed to the IBDP Coordinator. An appeal process may involve a reevaluation of the student’s records and an impartial review to confirm the validity
of the prediction.
</li>
<li>Final decisions regarding any changes in predicted grades will rest with the
Principal and IBDP Coordinator.</li>
          </ul>

          <li><h5 class="cam-title-heading"> <b>Communication with Students:</b></h5></li>
          <ul className='admission-clas'>
            <li>Facilitators should engage with students to set realistic expectations regarding
their university applications without explicitly stating or confirming predicted grades.</li>
<li>Discussions may focus on general areas for improvement and academic strategies
to optimize performance.</li>
            </ul>





</ol>
<h5 class="cam-title-heading"> <b>Review and Compliance:</b></h5>
<p>The policy will be reviewed annually by the IBDP Coordinator and the school
administration to ensure it aligns with the evolving IB guidelines and university
requirements. Facilitators must adhere strictly to this policy, and any breaches may
result in appropriate actions as per the school’s code of conduct.</p>

          </div>
          <br/>

      </div> },
{ title: 'Parent/Legal Guardian and Student Complaint Procedure', content: () => <div>

  <div className='cam-lower-sec'>
      <h1 className='title'>Parent/Legal Guardian and Student Complaint Procedure </h1>
        {/* <h5 className='cam-title-heading'>Sanskar School aims to:</h5> */}
        {/* <ul class="admission-class">
            <li>equip its pupils with a <b> critical and global outlook </b> which will make them
            committed citizens of the world</li>
            <li><b>recognize and channelize the potential</b> of the pupil and develop thinking, communication, social, scientific and interpersonal skills.</li>
            <li>foster <b> cognitive, affective and psychomotor development </b> and enable the pupil
            to make connections with the acquired knowledge in his/her everyday life.</li>
          </ul> */}
          <br/>
          <p>Sanskar School is committed to fostering a supportive, transparent, and fair learning environment. We 
value constructive feedback and believe that addressing concerns and appeals effectively strengthens 
trust within our school community. This document outlines a clear process for parents, legal guardians, 
and students to raise complaints, request reviews, or appeal IB programme-related decisions.</p>
      <br/>
<h5 class="cam-title-heading"><b>Scope</b></h5>
<p>This procedure applies to complaints related to:</p>
<ul className='admission-class'>

<ul className='admission-class'>
    <li>Academic concerns</li>
      <li>Student behaviour and discipline</li>
      <li>School policies and administration</li>
      <li>Teacher or staff conduct</li>
      <li>Safety, infrastructure, and facilities</li>
      <li>Appeals against decisions relating to IB programme requirements, assessments, or other determinations made by the school</li>
  </ul> 
  <h5 class="cam-title-heading"> <b>Guiding Principles</b></h5>
  <ul className='admission-class'>
    <li>All matters will be handled professionally, respectfully and confidentially.</li>
   
      <li>Complaints will be addressed objectively, ensuring fairness and impartiality. </li>
      <li>The school aims to resolve issues promptly and effectively. </li>
      <li>IB-related appeals will follow the IB’s regulations and timelines to ensure due process.</li>
    </ul> 

    <h5 class="cam-title-heading"> <b>Complaint & Appeals Process </b></h5>  
    <p><b>Step 1: Informal Discussion (Teacher/Staff Level)</b></p>
    <ul className='admission-class'>
      <li>Parents, guardians, or students should first attempt to resolve concerns by discussing the issue 
directly with the relevant teacher or staff member. </li>

      <li>This can be done through an in-person meeting, email, phone call, or WhatsApp message. </li>
      <li>Many issues are resolved effectively at this stage through open communication.</li>
    </ul>
    <br/>
     <p><b>Step 2: Escalation to the Coordinator</b></p>
       <ul className='admission-class'>
      <li>If the issue is not resolved, the complainant may escalate the matter to the Coordinator.</li>
    </ul>
    <br/>
     <p><b>Step 3: Formal Complaint to the Principal </b></p>
       <ul className='admission-class'>
      <li>If the Coordinator is unable to resolve the issue, a formal written complaint or appeal should be 
submitted to the Principal. A formal meeting may be scheduled with the principal. </li>
<li>In the case of an IB-related decision appeal, the request should clearly state: </li>
<ol>
  <li>The decision being challenged </li>
  <li> The grounds for appeal  </li>
  <li> Any supporting documents or evidence  </li>
</ol>
<li>The Principal will review the case, consult the IB Programme Coordinator, and ensure all IB 
regulations are followed. </li>
<li>A written decision will be provided to the student within a reasonable timeframe.</li>
    </ul>

     <br/>
     <p><b>Special Cases </b></p>
       <ul className='admission-class'>
      <li><b>Urgent Matters </b>(e.g., safety concerns) will be prioritized for immediate attention. </li>
      <li><b>Anonymous Complaints </b>will not be entertained unless they involve serious issues requiring 
investigation.</li>
      <li><b>Disciplinary Matters</b> involving students will follow the school’s disciplinary policy. </li>
      <li><b>IB Programme Appeals</b> will be processed in line with the IB’s own policies and deadlines.  </li>
    </ul>
    <br/>
    <p><b>Special Cases </b></p>
       <ul className='admission-class'>
        <li>This procedure is available on <b>Display Boards, School Website, and at the School Reception. </b></li>
        <li>IB-related appeal guidelines are also explained during <b>student orientation sessions</b>  to ensure all 
students understand their rights and the process.</li>
       </ul>

       <p><b>Contact Information</b></p>
            <ul className='admission-class'>
              <li>Teacher/Coordinator: Reach out via school diary, phone call, WhatsApp, or email. </li>
              <li>Principal: principal@sanskarjaipur.com  | School Reception: 0141-2246189, 2357844</li>
            </ul>
<p>Sanskar School values open communication and is committed to addressing concerns in a fair and 
efficient manner. We encourage parents, guardians, and students to follow this structured procedure for 
a smooth and constructive resolution of any issues. </p>
<br/>

<h5 class="cam-title-heading"> <b><u>IB Programme Appeals –Your Right to Appeal IB-Related Decisions</u></b></h5>

<br/>
<p><b>What is an IB Programme Appeal? </b></p>
<p>An appeal is when you formally ask the school to review a decision made about your IB work, 
requirements, or results <b>before they are submitted to the IB. </b></p>

<br/>
<p><b>You Can Appeal If the Decision Is About: </b></p>
<ul className='admission-class'>
  <li>Your IB subject choices or changes </li>
  <li>Internal assessment grades or marking  </li>
  <li>Predicted grades</li>
  <li>CAS, EE, or TOK requirements</li>
  <li>Any IB programme requirement the school has decided about you</li>
  </ul>

  <br/>

  <p><b>Steps to Appeal</b></p>
  <p><b>Step 1 – Talk to Your Teacher First </b></p>
    <ul className='admission-class'>
      <li>Share your concern and ask for clarification</li>
      <li>Many issues can be resolved at this stage </li>
    </ul>
    <br/>
  <p><b>Step 2 – Contact the IB Coordinator </b></p>
    <ul className='admission-class'>
      <li>Explain why you disagree with the decision</li>
      <li>Provide any evidence (assignments, feedback, messages) </li>
    </ul>
    <br/>
  <p><b>Step 3 – Submit a Written Appeal to the Principal  </b></p>
    <ul className='admission-class'>
      <li>State exactly which decision you’re appealing </li>
      <li>Give your reasons and any documents that support your case </li>
      <li>You will get a written reply after review</li>
    </ul>
    <br/>
      <p><b>Important Notes </b></p>
          <ul className='admission-class'>
            <li>Appeals must be made <b>within 5 school days </b> of being informed of the decision </li>
            <li>All appeals are handled confidentially and fairly </li>
            <li>If your appeal is accepted, necessary corrections or actions will be taken </li>
            <li>IB regulations will be followed for all decisions</li>

          </ul>
    <br/>
      <p><b>Where to Find the Full Rules? </b></p>
          <ul className='admission-class'>
            <li>School Reception</li>
            <li>School Website → Policies Section</li>
            <li>Notice Boards</li>
          </ul>
    <br/>
      <p><b>Contact for Appeals:</b></p>
          <ul className='admission-class'>
            <li><b>IB Coordinator: </b>Reach out via school diary, phone call, WhatsApp, or email. </li>
            <li><b>Principal: </b> principal@sanskarjaipur.com </li>
        
          </ul>

</ul>


          </div>
          <br/>

      </div> },
  
  ];


  return (
    <div>

      <div className='ibdp-hero-sec'>
        <img src='../newimg/admission-policy.webp'/>
      </div>
      
      <div className='ib-policy'>
      <HorizontalTabs tabs={tabs} />
      </div>
    </div>
  )
}

export default policy
